import type {OpenTelemetryClient} from '@shopify/opentelemetry-mini-client-private';

import {SendImmediatelyOpenTelemetryClient} from '~/foundation/OpenTelemetry/SendImmediatelyOpenTelemetryClient';
import {createExporter} from '~/foundation/OpenTelemetry/utils';

let telemetryClient: OpenTelemetryClient | undefined;

export function getTelemetryClient() {
  if (!telemetryClient) {
    telemetryClient = new SendImmediatelyOpenTelemetryClient({
      exporter: createExporter(),
      attributes: {
        feature: 'PaymentTerms',
      },
    });
  }

  return telemetryClient;
}

export function resetTelemetryClient() {
  telemetryClient = undefined;
}
